import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Filter from '../filter/filter.jsx';
import './filters.scss';

const Filters = (props) => {
  const handleServicesFilters = (event) => {
    let filters = props.servicesFilters.slice();
    if (event.target.value) {
      if (event.target.checked) {
        filters.push(event.target.value);
        props.setServicesFilters(filters);
      } else {
        filters = filters.filter((item) => item !== event.target.value);
        props.setServicesFilters(filters);
      }
    }
  };

  // Functions that manage interaction events with child functions
  const handleFilterItemChange = (filterType, event) => {
    // right now we have hard coded filter names/types defined
    // in the future we should refactor to be more flexible
    // Previously there was also a distance filter.
    // This code can likely be removed but would require a broader refactoring.
    if (filterType === 'services') {
      handleServicesFilters(event);
    }
  };

  // Functions that generate child components
  const isFilterItemChecked = (filterType, val) => {
    // right now we have hard coded filter names/types defined
    // in the future we should refactor to be more flexible

    if (filterType === 'services') {
      return props.servicesFilters.includes(val);
    }
    if (filterType === 'threshold') {
      return val === props.distanceFilter;
    }
    console.error('unknown filter type', filterType, val);
    return false;
  };

  const getFilterItem = (filter, option) => {
    // get an individual filter item (checkbox or radio)
    let val;
    let label;
    if (typeof option === 'string') {
      // ['10', '20', '50']
      val = option;
      label = option;
    } else if (typeof option === 'object') {
      // [{'label': 'Some Label', 'val': 'some-value'}]
      ({ val, label } = option);
    } else {
      console.error('cant determine filter type', typeof option);
    }

    return (
      <Filter
        key={val}
        filter={filter}
        handleChecked={isFilterItemChecked(filter.filter, val)}
        handleOnChange={handleFilterItemChange.bind(this, filter.filter)}
        label={label}
        value={val}
      />
    );
  };

  const getFilterItems = (filter) => {
    // dynamically generate the filter items
    const filterItemsJSX = [];
    filter.options.forEach((option) => {
      filterItemsJSX.push(getFilterItem(filter, option));
    });
    return filterItemsJSX;
  };

  // Collection of child elements
  const filterItems = getFilterItems(props.filter);
  const label = props.label || '';
  const legend = props.label ? (<legend className="sb-filter-title">{props.label}</legend>) : (<legend className="sb-filter-title">{`${i18n.t('Filter Search Results')}`}</legend>);

  return (
    <div className={`sb-filter sb-filter-${props.filter.filter}`}
      key={props.label}
      title={`${label} ${i18n.t('filtersContainer')}`}
    >
      <form
        className="sb-filter-form"
        title={`${label} ${i18n.t('filters')}`}
      >
        <fieldset>
          {legend}
          {filterItems}
        </fieldset>
      </form>
    </div>
  );
};

Filters.propTypes = {
  distanceFilter: PropTypes.string,
  filter: PropTypes.object,
  label: PropTypes.string,
  servicesFilters: PropTypes.array,
  setServicesFilters: PropTypes.func,
};

export default Filters;
